function StaffResume() {
    return (
      <div className="App">
          StaffResume
      </div>
    );
  }
  export default StaffResume;